import { useCallback, useReducer } from 'react';
import { OfertaViewReducer } from './OfertaViewReducer';
import { OfertaViewContext } from './OfertaViewContext';
import { UPDATE_MY_BANKS, UPDATE_BASIC_INFO, UPDATE_OFERTA_VIEW } from './types';

export const OfertaViewState = (props) => {

    const initialState = {
        myBanks:{
            myBankAccounts: [],
            parentAccount: {},
            openModalAddBank: false,
            openModalEditBank: false,
            accountToEdit: {}
        },
        basicInfo: {},
        ofertaViewData: {}
    }

    const [state, dispatch] = useReducer(OfertaViewReducer, initialState);

    const updateMyBanks = useCallback((data) => {
        dispatch({
            type: UPDATE_MY_BANKS,
            payload: data
        })
    }, [])

    const updateBasicInfo= (data) => {
        dispatch({
            type: UPDATE_BASIC_INFO,
            payload: data
        })
    }

    const updateOfertaView = (data) => {

        dispatch({
            type: UPDATE_OFERTA_VIEW,
            payload: data
        })
    }

    return (
        <OfertaViewContext.Provider value={
            {
                myBanks: state.myBanks,
                updateMyBanks,
                basicInfo: state.basicInfo,
                updateBasicInfo,
                ofertaViewData: state.ofertaViewData,
                updateOfertaView
            }}>
            {props.children}
        </OfertaViewContext.Provider>
    )

}


